export default "__VITE_ASSET__CSm26EuG__"